import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=1fa26d53&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=ts"
export * from "./recommend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa26d53",
  null
  
)

export default component.exports